<template>
  <div
    id="main"
    style="height:400px;background-color: #fff;padding: 15px;margin-bottom: 8px;"
  ></div>
</template>

<script>
import { getRunningChart } from "@/api/analysis";
import { mapState } from "vuex";

export default {
  name: "RunningChart",
  props: {
    chartParams: Object
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("main"));
      let option = {};

      getRunningChart({
        userID: this.accountInfo.userID,
        ...this.chartParams
      }).then(response => {
        var dataShadow = [];

        for (var i = 0; i < response.data.count.length; i++) {
          dataShadow.push(response.data.max);
        }

        option = {
          title: {
            text: "Daily Report",
            left: "center",
            top: 20,
            textStyle: {
              color: "#ccc"
            }
          },
          grid: {
            left: 50,
            right: 50,
            bottom: 50,
            top: 50
          },
          tooltip: {
            show: true,
            trigger: "item"
          },
          legend: {
            show: false
          },
          xAxis: {
            data: response.data.date,
            axisLabel: {
              inside: false,
              textStyle: {
                color: "#999"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            z: 10
          },
          yAxis: {
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "#999"
              }
            }
          },
          series: [
            {
              // For shadow
              type: "bar",
              itemStyle: {
                color: "rgba(0,0,0,0.05)"
              },
              barGap: "-100%",
              barCategoryGap: "40%",
              data: dataShadow,
              animation: false
            },
            {
              // For shadow
              type: "bar",
              itemStyle: {
                color: "rgba(0,0,0,0.05)"
              },
              barGap: "-100%",
              barCategoryGap: "40%",
              data: response.data.count,
              animation: false
            },
            {
              type: "bar",
              itemStyle: {
                color: "#83bff6"
              },
              emphasis: {
                itemStyle: {
                  color: "#2378f7"
                }
              },
              data: response.data.count
            }
          ]
        };
        myChart.setOption(option);
      });
    }
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  watch: {
    chartParams: function() {
      this.drawChart();
    }
  }
};
</script>
